import getSession from './getSession';

/*
 * Sends the user an email containing a verification code for the specified attribute.
 *
 * @returns {Object} result - The response object from Cognito
*/
function getAttributeVerificationCode(attribute) {
  return new Promise((resolve, reject) => {
    return getSession()
      .then(cognitoUser => {
        cognitoUser.getAttributeVerificationCode(attribute, {
            onSuccess: function (result) {
              return resolve(result);
            },
            onFailure: function(err) {
              return reject(err);
            },
            inputVerificationCode: null
        });
      })
      .catch(err => {
        return reject(err);
      });
  });
}

/*
 * Attempts to verify the given attribute using the given code.
 *
 * @returns {Object} result - The response object from Cognito
*/
function verifyAttribute(attribute, code) {
  return new Promise((resolve, reject) => {
    return getSession()
      .then(cognitoUser => {
        cognitoUser.verifyAttribute(attribute, code, {
          onSuccess: function (result) {
            return resolve(result);
          },
          onFailure: function(err) {
            return reject(err);
          },
        });
      })
      .catch(err => {
        return reject(err);
      });
  });
}

export { getAttributeVerificationCode, verifyAttribute };



// WEBPACK FOOTER //
// ./src/cognito/verifyUserAttribute.js